import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import makerjs from "makerjs";
import {isEmpty} from "lodash";

export class Octagon extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'octagon', dimensions );
	}

	getSideLength(): Length {
		return this.cleanedPrimitives.side_length;
	}

	getLength(): Length {
		return this.cleanedPrimitives.side_length;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.side_length;
	}

	getHeight(): Length {
		const height = (1 + Math.sqrt(2)) * this.getSideLength().in_mm();

		return Length.from_mm( height );
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'side_length' };
	}

	getRadius(): Length {
		const sides = 8;
		const angleInRadians = Math.PI / sides;
		const sinAngle = Math.sin( angleInRadians );
		const radius = this.getSideLength().in_mm() / ( 2 * sinAngle );
		return Length.from_mm( radius );
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		let dimensionLines = [];

		// Calculate the sloped side radius
		const angleInRadians = Math.PI / 4;
		const sinAngle = Math.sin( angleInRadians );
		const radius = this.getSideLength().in_mm() / ( 2 * sinAngle );
		const offset = Length.from_mm( radius );

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			dimensionLines = [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height', this.getHeight().in_cm() ), [-40, 0], ratio ),
				new DimensionLine( [0, 0], [ this.getHeight().in_mm(), 0 ], this.renderDimensionLabel( 'width', this.getHeight().in_cm() ), [0, -40], ratio ),
			];
		}

		if(focusedElement.includes("measurements-octagon-side_length")) {
			dimensionLines.push(new DimensionLine( [offset.in_mm(), 0], [ this.getSideLength().add(offset).in_mm(), 0 ], this.renderDimensionLabel( 'side_length' ), [0, 40], ratio, this.getDimensionLineType('measurements-octagon-side_length', focusedElement, forceRender) ));
		}

		return dimensionLines;
	}

	/**
	 * Creates a model instance of the shape.
	 */
	createModel(): void {
		if ( isEmpty( this.cleanedPrimitives ) ) {
			return;
		}

		super.createModel();

		makerjs.model.zero( this.model );
		makerjs.model.originate( this.model );
	}

	getDefaultDimensions(): Dimensions {
		return { side_length: 20 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			side_length: width.divide(4).in_cm(),
		};
	}
}
